export default {
  message: {
    "error": "Ein Fehler ist aufgetreten!",
    "Sorrysomeerrorsoccurred": "Entschuldigung, es sind einige Fehler aufgetreten",
    "quit": "Beenden",
    "language": "Sprache",
    "Youcanchangethelanguagehere": "Hier können Sie die Sprache ändern!",
    "current": "Aktuell",
    "home": "Startseite",
    "friends": "Freunde",
    "wallet": "Wallet",
    "aboutus": "Über uns",
    "Sharewithfriends": "Mit Freunden teilen",
    "copyFailure": "Kopieren fehlgeschlagen",
    "copySuccess": "Kopieren erfolgreich",
    "Claimreward": "Belohnung erhalten",
    "DailyLogin": "Täglicher Login",
    "noInvitationsYet": "Noch keine Einladungen",
    "LoadMore": "Mehr laden",
    "WatchAD": "Anzeige ansehen",
    "continue": "Fortfahren",
    "Congratulations": "Herzlichen Glückwunsch",
    "MyFriends": "Meine Freunde",
    "Invitefriends": "Freunde einladen",
    "Invitepremiumfriends": "Premium-Freunde einladen",
    "DailyTasks": "Tägliche Aufgaben",
    "inviteDesc": "+{num} ${name} für jeden Freund, den Sie einladen",
    "DailyTasksDesc": "Aufgaben erfüllen, um mehr ${name} zu erhalten",
    "SponsorsandPartners": "Sponsoren und Partner",
    "Receivingwallet": "Empfangende Wallet",
    "Enterwalletaddress": "Geben Sie die {name} Wallet-Adresse ein",
    "Claim": "Belohnung erhalten",
    "Booster": "Booster",
    "RentPeriod": "Mietzeitraum",
    "days30": "30 Tage",
    "days": "Tage",
    "Dailyprofit": "Täglicher Gewinn",
    "Totalprofit": "Gesamtgewinn",
    "Quantity": "Menge",
    "RentPrice": "Mietpreis",
    "RentMiner": "Minen mieten",
    "Insufficient": "Unzureichende ${name}",
    "InsufficientMsg": "{num} ${name1} benötigt, laden Sie Freunde ein oder erfüllen Sie Aufgaben, um mehr ${name2} zu verdienen.",
    "Settings": "Einstellungen",
    "copyid": "ID kopieren",
    "UpgradeSuccessfully": "Upgrade erfolgreich",
    "Name": "Name",
    "userinfo": "Benutzerinfo",
    "disconnect": "Trennen",
    "Startmining": "Mit dem Mining beginnen",
    "Welcome": "Willkommen bei {name}",
    "Withdrawal": "Abhebung",
    "Minimumamount": "Mindestsumme",
    "Networkfee": "Netzgebühr",
    "Enteramount": "Betrag eingeben",
    "Submit": "Einreichen",
    "MinimumTip": "Der Abhebungsbetrag ist zu klein. Mindestabhebungsbetrag: {num}",
    "MaximumTip": "Unzureichender Betrag, der maximale Betrag, den Sie abheben können, ist: {num}",
    "SubmittedTip": "Einreichung erfolgt, voraussichtlich innerhalb von 30-60 Werktagen bearbeitet",
    "WebSubmittedTip": "Einreichung erfolgt, voraussichtlich innerhalb von 24-48 Stunden bearbeitet",
    "WithdrawStatus": "Status",
    "Submissiontime": "Einreichungszeit",
    "WithdrawAwaitTip": "* Es wird geschätzt, dass es 30-60 Werktage dauert. Das Einladen von Freunden kann den Überprüfungsprozess beschleunigen.",
    "WebWithdrawAwaitTip": "* Es wird geschätzt, dass es 24-48 Stunden dauert. Das Einladen von Freunden kann den Überprüfungsprozess beschleunigen.",
    "Processing": "Bearbeitung",
    "Success": "Erfolg",
    "Rejection": "Abgelehnt",
    "Amount": "Betrag",
    "Numberoffriends": "Anzahl der Freunde: {now}/{limit}",
    "InviteTip": "Um Ihre erste Abhebung vorzunehmen, müssen Sie {limit} Freunde einladen, um der Mining-App beizutreten.",
    "openonphone": "Öffnen Sie diesen Link auf Ihrem Telefon.",
    "claimTip": "Der Betrag zum Einsammeln ist zu klein. Der Mindestbetrag zum Einsammeln beträgt: {num}",
    "WalletBalance": "Wallet-Balance",
    "Withdraw": "Abheben",
    "SetWalletAddress": "Wallet-Adresse festlegen",
    "WithdrawalRecord": "Abhebeprotokoll",
    "Norecords": "Keine Protokolle",
    "Whatis": "Was ist {name}?",
    "All": "Alle",
    "save": "Speichern",
    "successWithdrawal": "Abhebung wurde empfangen {num}",
    "secondsago": "Vor {time} Sekunden",
    "Loading": "Lädt...",
    "PaymentConfirming": "Überprüfen des Transaktionsstatus...",
    "Check": "Überprüfen",
    "CheckFail": "Transaktion nicht abgeschlossen. Bitte in 5 Sekunden erneut überprüfen.",
    "Addname": "'{name}' zu Ihrem Namen hinzufügen",
    "Restattcheck": "App neu starten, um zu überprüfen",
    "Copyname": "'{name}' kopieren",
    "SubmissionFailed": "Einreichung fehlgeschlagen, bitte später erneut versuchen",
    "WithdrawalReview": "Abhebungsüberprüfung",
    "shop": "Shop",
    "topurchase": "Gehen Sie zum Shop, um einzukaufen",
    "shopDesc": "Begrenzte Verfügbarkeit—sichern Sie sich Ihres, bevor sie verschwinden!",
    "select_payment_method": "Zahlungsmethode auswählen",
    "total_amount": "Gesamtbetrag",
    "creating_order": "Bestellung wird erstellt...",
    "order_created": "Bestellung erstellt",
    "order_status": "Bestellstatus",
    "claim": "Belohnungen einsammeln",
    "payment_success": "Zahlung erfolgreich",
    "payment_failed": "Zahlung fehlgeschlagen",
    "payment_cancelled": "Zahlung abgebrochen",
    "opening_payment": "Zahlung wird geöffnet...",
    "payment_status": "Zahlungsstatus",
    "create_order_failed": "Bestellung erstellen fehlgeschlagen",
    "creating_ton_order": "TON-Bestellung wird erstellt...",
    "next_step": "Nächster Schritt",
    "use_ton_payment": "TON-Zahlung verwenden",
    "start_transaction": "Transaktion starten",
    "connect_wallet": "Wallet verbinden",
    "address": "Adresse",
    "amount_ton": "Betrag TON",
    "copy": "Kopieren",
    "amount": "Betrag",
    "wallet_address": "Wallet-Adresse",
    "comment_memo": "Kommentarnotiz",
    "you_can_choose_to_connect_wallet_to_pay": "Sie können wählen, ob Sie die Wallet zum Bezahlen verbinden möchten",
    "or_manually_transfer_to_the_above_address": "Oder manuell an die oben stehende Adresse überweisen (bitte beachten, dass der Betrag und die Notiz genau gleich sein müssen)",
    "transaction_success": "Transaktion erfolgreich",
    "transaction_failed": "Transaktion fehlgeschlagen",
    "transaction_error": "Transaktionsfehler",
    "transaction_status": "Transaktionsstatus",
    "transaction_id": "Transaktions-ID",
    "transaction_amount": "Transaktionsbetrag",
    "transaction_status_desc": "Beschreibung des Transaktionsstatus",
    "payment_status_tip": "Bitte warten Sie, bis die Zahlung bestätigt ist",
    "Applyforwithdrawal": "Abhebung beantragen",
    "Withdrawalunlock": "Abhebung entsperren",
    "Close": "Schließen",
    "Delivering": "Lieferung",
    "Duetothelargenumber": "Aufgrund der großen Anzahl von Empfängern wird Ihr Airdrop voraussichtlich in 15-20 Werktagen eintreffen",
    "WithdrawalunlockTip": "Sie benötigen {num} eingeladene Freunde, um Aufgaben abzuschließen/Wallets zu binden, um die Abhebung freizuschalten",
    "select_network": "Netzwerk auswählen",
    "confirm": "bestätigen",
    "switching_network": "Netzwerk wechseln...",
    "network_switched": "Netzwerk gewechselt",
    "use_usdt_payment": "Nutze USDT-Zahlung",
    "or_manually_transfer_to_the_above_address_usdt": "Überweisen Sie manuell an die oben angegebene Adresse (bitte beachten Sie, dass der Betrag und die Adresse genau gleich sein müssen)",
    "chain_type": "Netzwerk",
    "check_transaction_status": "Transaktionsstatus überprüfen",
    "transaction_wait": "Die Transaktion wird bearbeitet. Sie können die App schließen. Eine Nachricht wird Sie benachrichtigen, sobald sie abgeschlossen ist.",
    "twa_pay_tip_with_memo": "Bitte stellen Sie sicher, dass die Adresse, der Betrag und die Notiz für die Überweisung übereinstimmen.",
    "twa_pay_tip": "Bitte stellen Sie sicher, dass die Adresse und der Betrag für die Überweisung korrekt sind.",
    "creating_usdt_order": "USDT-Bestellung wird erstellt...",
    "affiliate_programs": "Affiliate-Programme",
    "affiliate_programs_description": "Lade Freunde ein, um der Mining-App beizutreten und Belohnungen zu verdienen.",
    "commission_details": "Provisionsdetails",
    "no_commission_records": "Keine Provisionsunterlagen",
    "commission_list": "Provisionsliste",
    "input_amount": "Betrag eingeben",
    "max": "Max",
    "commission_input_amount": "Provisionsbetrag eingeben",
    "min_commission": "Der minimale Auszahlungsbetrag beträgt {num}",
    "WithdrawalSuccess": "Auszahlung erfolgreich",
    "WithdrawalFailed": "Auszahlung fehlgeschlagen",
    "WithdrawalProcessing": "Auszahlung wird bearbeitet",
    "award": "Auszeichnung",
    "level": "Stufe",
    "Share_to_group": "In Gruppe teilen",
    "Exchange": "Exchange",
    "balance_not_enough": "Saldo nicht ausreichend, Sie können nur {num} {coin} eintauschen",
    "exchange_fail": "Exchange fehlgeschlagen",
    "exchange_success": "Exchange erfolgreich",
    "you_will_receive": "Sie werden erhalten",
    "ShareToGroups": "In Gruppen teilen",
    "Numberofgroups": "Anzahl der Gruppen: {now}/{limit}",
    "Confirm": "Bestätigen",
    "ShareToGroupsDesc": "Teilen Sie in Gruppen, um mehr {name} zu erhalten",
    "TokenAddress": "Bitte geben Sie die Abhebungsdetails wie die Exchange-ID oder die USDT-Adresse ein",
    "CashAddress": "Bitte geben Sie die Abhebungsdetails wie die Kreditkartennummer oder die USDT-Adresse ein",
    "Cancel": "Abbrechen",
    "min_withdrawal_amount": "Der minimale Abhebungsbetrag beträgt {num} {coin}",
    "max_withdrawal_amount": "Der maximale Abhebungsbetrag beträgt {num} {coin}",
    "withdrawal_failed": "Abhebung fehlgeschlagen",
    "withdrawal_success": "Abhebung erfolgreich",
    "PayNow": "Jetzt bezahlen",
    "PaySkip": "Bezahle {num}, um die Auszahlung sofort freizuschalten",
    "NumberofGroups": "Anzahl der Gruppen: {now}/{limit}",
    "SendMessage": "Nachricht senden",
    "NumberofShares": "Anzahl der Anteile: {now}/{limit}",
    "NumberofTasks": "Anzahl der Aufgaben: {now}/{limit}",
    "CompleteTask": "Aufgabe abschließen",
    "PleaseEnterValidAmount": "Bitte geben Sie einen gültigen Betrag ein",
    "PleaseEnterValidEmail": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "Feedback": "Rückmeldung",
    "Inputfeedbackcontent": "Geben Sie den Rückmeldungsinhalt ein",
    "Submitfeedback": "Rückmeldung einreichen",
    "Pleaseenteravalidemailaddress": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "Pleaseenteryouremailaddress": "Bitte geben Sie Ihre E-Mail-Adresse ein",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "Sie haben heute bereits festgestellt, bitte kommen Sie morgen wieder",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "Rückmeldung erfolgreich eingereicht, vielen Dank für Ihr wertvolles Feedback",
    "Feedback_submission_failed_please_retry": "Einreichung der Rückmeldung fehlgeschlagen, bitte versuchen Sie es erneut",
    "ContactUs": "Kontaktieren Sie uns",
    "XRPAddress": "Bitte geben Sie die aktivierte XRP-Ketten-Wallet-Adresse (einschließlich MEMO) ein, andernfalls können Sie kein Geld abheben.",
    "Accelerated": "Beschleunigt",
    "Accelerated_withdrawals_success": "Beschleunigte Abhebungen erfolgreich",
    "login": "Anmelden",
    "register": "Registrieren",
    "login_with_google": "Mit Google anmelden",
    "or": "ODER",
    "email": "E-Mail",
    "password": "Passwort",
    "no_account": "Kein Konto?",
    "click_to_go": "Klicken Sie hier um",
    "have_account": "Haben Sie bereits ein Konto?",
    "go_to": "Gehe zu",
    "invite_code": "Einladungscode",
    "optional": "Optional",
    "google_login_not_ready": "Google-Anmeldung ist nicht bereit, bitte versuchen Sie es später erneut",
    "password_too_long": "Passwort ist zu lang",
    "weak": "Schwach",
    "medium": "Durchschnittlich",
    "strong": "Stark",
    "login_success": "Anmeldung erfolgreich",
    "login_failed": "Anmeldung fehlgeschlagen",
    "please_input_email": "Bitte geben Sie Ihre E-Mail ein",
    "invalid_email": "Ungültiges E-Mail-Format",
    "please_input_password": "Bitte geben Sie Ihr Passwort ein",
    "password_length_6_to_16": "Das Passwort muss 6-16 Zeichen lang sein",
    "account_or_password_error": "Konto- oder Passwortfehler",
    "register_success": "Registrierung erfolgreich",
    "register_failed": "Registrierung fehlgeschlagen",
    "save_error": "Speicherfehler, bitte versuchen Sie es später erneut",
    "ShareToFriends": "Teile es mit Freunden",
    "login_first": "Bitte zuerst einloggen",
    "WalletBscError": "❌ Ungültige BNB Chain-Wallet-Adresse.",
    "DownloadWallet": "Wallet herunterladen",
    "AddToHomeScreen": "Füge {appName} zum Startbildschirm hinzu",
    "TapShareInToolbar": "Tippe in der Symbolleiste",
    "SelectAddToHomeScreen": "Wähle \"Zum Startbildschirm hinzufügen\"",
    "OpenToolbar": "Symbolleiste öffnen",
    "ClaimFailed": "Belohnung konnte nicht abgeholt werden, bitte versuchen Sie es später erneut",
    "guest_login": "Gast-Login",
    "please_input_phone": "Bitte geben Sie Ihre Telefonnummer ein",
    "email_error_1": "Bitte geben Sie Ihre E-Mail-Adresse ein",
    "email_error_2": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "email_error_3": "Gast-E-Mail ist nicht erlaubt, bitte verwenden Sie eine echte E-Mail",
    "phone": "Telefon",
    "phone_error_1": "Bitte geben Sie Ihre Telefonnummer ein",
    "phone_error_2": "Bitte geben Sie eine gültige Telefonnummer ein",
    "update_info": "Informationen aktualisieren",
    "update_success": "Aktualisierung erfolgreich",
    "update_failed": "Aktualisierung fehlgeschlagen, bitte versuchen Sie es später erneut",
    "cancel": "Abbrechen",
    "guest_credentials_title": "Kontoinformationen",
    "guest_credentials_warning": "Bitte machen Sie einen Screenshot, um Ihr Konto und Ihr Passwort zu sichern. Wenn sie verloren gehen, können Ihre Einnahmen nicht wiederhergestellt werden!",
    "i_have_saved": "Ich habe gespeichert",
    "account": "Konto",
    "view_credentials": "Zugangsdaten anzeigen",
    "miner_max_reached": "Sie haben die maximale Anzahl dieses Miners erreicht"
}};